import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, ListCheck, CalendarDays, Gift, Image, Eye, Coins } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import ShimmerLoader from '../../hooks/ShimmerLoader';
import { creatVoucher, getvoucherlist, fetchstores } from "../../services/api";
import Pagination from "../../hooks/Pagination";
import { fetchLoyaltyProgramsForRewards } from "../../store/loyaltySlices/loyaltyRewardsSlice";

import toastr from 'toastr';

import "flatpickr/dist/themes/light.css";
import dayjs from "dayjs";

import { DateInput } from "@mantine/dates";

export default function Voucher() {
  useDocumentTitle('Welcome to Admin | Loyalty Card');
  const [voucher, setVoucher] = useState([]);
  const [storelist, setStoreList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSave, setSave] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const wrapperRef = useRef(null);
  const [suggestions, setSuggestions] = useState([]);
  const [isViewOnly, setIsViewOnly] = useState(false);

  const dispatch = useDispatch();
  const viewerIsStore = window.location.pathname.startsWith("/store-panel");
  const { programs: loyalty_program } = useSelector((state) => state.loyaltyRewards);
  // active memberships only, shaped for the checkbox list
  const membershipList = (loyalty_program || [])
    .filter((p) => Number(p.is_active) === 1)
    .map((p) => ({ id: Number(p.program_id), program_name: p.program_name }));

  const perPage = 20;
  const fetchLoyaltyCard = async (perPage, currentPage) => {
    try {
      const response = await getvoucherlist(perPage, currentPage);
      const data = await response.data;
      setVoucher(data.data || data); // Adjust based on your API response structure
      setCurrentPage(data.current_page);
      setTotalPages(data.last_page);
    } catch (err) {
      setError(err.message || 'Failed to fetch Loyalty Card');
    } finally {
      setLoading(false);
    }
  };

  const fetchStore = async (keyword = '') => {
    try {
      const response = await fetchstores(25, 1, keyword);
      const data = await response.data;
      if (keyword.length > 2) {
        setSuggestions(data.data || data);
      } else {
        setStoreList(data.data || data);
      }

    } catch (err) {
      setError(err.message || 'Failed to store');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    dispatch(fetchLoyaltyProgramsForRewards());
  }, [dispatch]);
  useEffect(() => {
    fetchStore()
    fetchLoyaltyCard(perPage, currentPage);
  }, [currentPage]);
  const initialFormData = {
    stores_id: [],
    memberships: [],
    no_of_voucher: 0,
    discount_value: 0,
    voucher_price: 0,
    max_discount_value: 0,
    discount_type: '1',
    gtcoin_required: '0',
    is_active: "1",
    voucher_name: '',
    terms_condition: "",
    valid_from: null,
    points_required: 0,
    valid_to: null,
    voucher_logo: null,
    required_value: 0,
    customer_share: '',
    owner_share: '',
    redemption_type: '3',
    min_purchase_value: '',
  };
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const handleOpen = () => {
    setOpen(!open)
    setIsViewOnly(false);
    setSelected([]);
    setFormData(initialFormData)
  };

  const handleChange = (e, field = '') => {
    let name = '';
    let value = '';

    if (e.target) {
      name = e.target.name;

      if (e.target.multiple) {
        // Handle multiple select values
        value = Array.from(e.target.options)
          .filter(option => option.selected)
          .map(option => option.value);
      } else {
        value = e.target.value;
      }
    } else {
      name = field;
      value = e;
    }

    setFormData(prev => {
      const next = { ...prev, [name]: value };

      // Switching to percentage: clear both discount value and max discount value
      if (name === 'discount_type' && value === '2') {
        next.discount_value = '';
        next.max_discount_value = '';
      }
      // Switching to fixed: max discount mirrors the fixed discount value
      if (name === 'discount_type' && value === '1') {
        next.max_discount_value = prev.discount_value;
      }
      // Fixed type: keep max discount in sync with the discount value
      if (name === 'discount_value' && next.discount_type === '1') {
        next.max_discount_value = value;
      }
      return next;
    });
  };

  // const handleChangeImg = (e, field = '') => {
  //   const { name, type, files } = e.target;
  //   if (type === "file" && files.length > 0) {
  //     const file = files[0];
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setFormData((prev) => ({
  //         ...prev,
  //         [name]: file, // actual file
  //         [`${name}_preview`]: reader.result, // preview URL
  //       }));
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    toastr.options = {
      closeButton: true,
      progressBar: true,
      timeOut: 3000,
      positionClass: 'toast-top-center'
    };

    if (isViewOnly) {
        toastr.warning("This voucher has been bought and cannot be edited.");
        return;
    }

    if (selected.length === 0) {
      toastr.error('Select at least one store Name', { timeOut: 2000 });
      return false
    }
    if (formData.memberships.length === 0) {
      toastr.error('Select at least one membership', { timeOut: 2000 });
      return false
    }
    if (formData.voucher_name === '') {
      toastr.error('Enter voucher name', { timeOut: 2000 });
      return false
    }
    if (formData.no_of_voucher === '' || formData.no_of_voucher === 0) {
      toastr.error('Enter No of voucher', { timeOut: 2000 });
      return false
    }
    if (formData.discount_value === '' || formData.discount_value === 0) {
      toastr.error('Enter Discount value', { timeOut: 2000 });
      return false
    }
    if (!formData.voucher_price || Number(formData.voucher_price) <= 0) {
      toastr.error('Enter Voucher price', { timeOut: 2000 });
      return false
    }
    if (!formData.max_discount_value || Number(formData.max_discount_value) <= 0) {
      toastr.error('Enter Max discount value', { timeOut: 2000 });
      return false
    }
    const maxDiscount = Number(formData.max_discount_value);
    if (maxDiscount > Number(formData.voucher_price)) {
      toastr.error('Max discount value cannot be greater than voucher price', { timeOut: 2000 });
      return false
    }
    if (formData.discount_type === '1' && maxDiscount > Number(formData.discount_value)) {
      toastr.error('Max discount value cannot be greater than the fixed discount value', { timeOut: 2000 });
      return false
    }
    if (formData.customer_share === '' || formData.owner_share === '') {
      toastr.error('Enter customer share and owner share', { timeOut: 2000 });
      return false
    }
    const shareSum = Math.round((Number(formData.customer_share) + Number(formData.owner_share)) * 100) / 100;
    if (shareSum !== 100) {
      toastr.error('Customer share and owner share must total 100%', { timeOut: 2000 });
      return false
    }
    if (formData.terms_condition === '') {
      toastr.error('Enter terms & condition', { timeOut: 2000 });
      return false
    }
    if (formData.gtcoin_required === '1') {
      if (formData.required_value === '' || formData.required_value === 0) {
        toastr.error('Enter GTcoin required value', { timeOut: 2000 });
        return false
      }
    }
     if (!formData.min_purchase_value || Number(formData.min_purchase_value) < 0) {
      toastr.error('Enter min. purchase value', { timeOut: 2000 });
      return false
    }
    // for (let key in formData) {
    //   formDataToSend.append(key, formData[key]);
    // }
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, Array.isArray(value) ? JSON.stringify(value) : value);
    });
    try {
      setSave(true)
      const response = await creatVoucher(formDataToSend);
      if (response.status.success) {
        fetchLoyaltyCard(perPage, currentPage);
        setOpenTR(0)
        setOpen(false)
        toastr.success(response.message)
        setFormData(initialFormData);
        setSave(false)
      } else {
        setSave(false)
        toastr.error(response.message)
      }
    } catch (error) {
      setSave(false)
      toastr.error("Add voucher failed. Please try again.");
    }
  }
  const [openTR, setOpenTR] = useState(0);
  const [openTRLoading, setOpenTRLoading] = useState(false);
  const [ParentData, setParentData] = useState([]);
  const handleOpenMore = async (reward_id, key) => {
    setOpenTR(prev => (prev === key ? 0 : key));
    setOpenTRLoading(true)
  }

  const handleEdit = ((item) => {
    const isPurchased = item.used_status != null;

    setIsViewOnly(isPurchased);

    if (isPurchased) {
        toastr.warning(
            "This voucher has been bought. You cannot edit it, but you can view its details."
        );
    }

    const store = {
      id: parseInt(item.store_id),
      store_name: item.store_name.trim()
    }
    setSelected([store]);
    setFormData({
      id: item.id,
      stores_id: JSON.stringify([store]),
      memberships: (item.memberships || []).map(Number),
      redemption_type: String(item.redemption_type ?? 3),
      customer_share: item.customer_share ?? '',
      owner_share: item.owner_share ?? '',
      no_of_voucher: item.no_of_voucher,
      discount_value: item.discount_value,
      voucher_price: item.voucher_price,
      max_discount_value: item.discount_type.toString() === '1' ? item.discount_value : item.max_discount_value,
      min_purchase_value:item.min_purchase_value,
      is_active: item.is_active.toString(),
      voucher_name: item.voucher_name,
      terms_condition: item.terms_condition,
      valid_from: (item.valid_from) ? dayjs(item.valid_from).format("YYYY-MM-DD") : null,
      valid_to: (item.valid_to) ? dayjs(item.valid_to).format("YYYY-MM-DD") : null,
      required_value: item.required_value,
      gtcoin_required: item.gtcoin_required.toString(),
      discount_type: item.discount_type.toString(),
      approval_status: item.approval_status,
      reject_reason: item.reject_reason,
    });
    setOpen(true)
  })

  const handleToarray = ((storeString) => {
    const storeArray = storeString.split(',').map(item => {
      const [id, name] = item.trim().split(':');
      return {
        id: parseInt(id),
        store_name: name.trim()
      };
    });
    return storeArray
  })

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsFocused(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [storeOptions, setStoreOptions] = useState([]);

  const filteredOptions = storeOptions.filter(
    (store) =>
      store.store_name.toLowerCase().includes(search.toLowerCase()) &&
      !selected.find((s) => s.id === store.id)
  );


  useEffect(() => {
    const fetchOnNoMatch = async () => {
      if (search.trim() && filteredOptions.length === 0 && !loading) {
        fetchStore(search)
        setTimeout(function () {
          setStoreOptions(storelist);
        }, 500);
      } else {
        setStoreOptions(storelist);
      }
    };
    fetchOnNoMatch();
  }, [search, isFocused]);

  const addStore = (store) => {
    const selectedStore = {
      id: store.id,
      store_name: store.store_name,
    };
    const newSet = [...selected, selectedStore]
    setSelected(newSet);
    setFormData(prev => ({
      ...prev,
      ['stores_id']: JSON.stringify(newSet)
    }));
    setSearch("");
  };

  const removeStore = (id) => {
    const newSet = selected.filter((store) => store.id !== id)
    setSelected(newSet);
    setFormData(prev => ({
      ...prev,
      ['stores_id']: JSON.stringify(newSet)
    }));
  };
  const redeemLabel = { 1: 'Online', 2: 'Offline', 3: 'Both' };

  const isAllMemberships = membershipList.length > 0 &&
    membershipList.every((m) => formData.memberships.includes(m.id));

  const toggleAllMemberships = () => {
    setFormData(prev => ({
      ...prev,
      memberships: isAllMemberships ? [] : membershipList.map(m => m.id),
    }));
  };

  const toggleMembership = (id) => {
    setFormData(prev => ({
      ...prev,
      memberships: prev.memberships.includes(id)
        ? prev.memberships.filter(x => x !== id)
        : [...prev.memberships, id],
    }));
  };

  const shareTotal = Math.round((Number(formData.customer_share || 0) + Number(formData.owner_share || 0)) * 100) / 100;
  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-4">

      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <form onSubmit={handleSubmit}>
            <div className="bg-white rounded-lg shadow-xl min-w-[300px] w-[60vw] max-w-[900px] max-h-[95vh] flex flex-col">
              <div className="flex justify-between items-center border-b px-6 py-4">
                <h3 className="text-lg font-semibold">
                  {isViewOnly
                      ? "View Voucher"
                      : formData.id
                          ? "Edit Voucher"
                          : "Add Voucher"}
                </h3>
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <fieldset disabled={isViewOnly} className="contents">
              <div className="p-4 space-y-4 overflow-y-auto flex-grow">
                {viewerIsStore && (
                  <div className="rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800">
                    {formData.id
                      ? 'You can deactivate an approved voucher immediately. Changes to other voucher details require admin approval.'
                      : 'Vouchers created by a store remain inactive until admin approval.'}
                  </div>
                )}
                {isViewOnly && (
                    <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
                        This voucher has been bought and cannot be edited.
                        You can view its details only.
                    </div>
                )}
                {formData.id && Number(formData.approval_status) === 2 && (
                  <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
                    <div className="font-medium">Rejected by admin</div>
                    {formData.reject_reason && <div>Reason: {formData.reject_reason}</div>}
                    {viewerIsStore && <div className="mt-1">Update the voucher and save it to submit it for approval again.</div>}
                  </div>
                )}
                <div ref={wrapperRef} className="grid grid-cols-1 md:grid-cols-1 gap-4">
                  <div className="border border-gray-300 rounded-md p-2 min-h-[48px] flex flex-wrap gap-1"
                  // onClick={() => document.getElementById("store-input").focus()}
                  >
                    {selected.map((store, key) => (
                      <span
                        key={store.id + '-' + key}
                        className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-sm flex items-center"
                      >
                        {store.store_name}
                        <button
                          onClick={() => removeStore(store.id)}
                          className="ml-1 text-blue-500 hover:text-blue-700"
                        >
                          &times;
                        </button>
                      </span>
                    ))}

                    <input
                      id="store-input"
                      type="text"
                      className="flex-grow outline-none p-1 text-sm"
                      placeholder="Search by store/events name, email or mobile..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      onFocus={() => setIsFocused(true)}
                    // onBlur={() => setTimeout(() => setIsFocused(false), 150)} // small delay to allow click
                    />
                  </div>

                  {isFocused && filteredOptions.length > 0 && (
                    <ul className="border border-gray-300 rounded-md max-h-60 overflow-y-auto bg-white shadow">
                      {filteredOptions.map((store) => (
                        <li
                          key={store.id}
                          className="px-3 z-10 py-2 hover:bg-blue-100 cursor-pointer text-sm"
                          onClick={() => addStore(store)}
                        >
                          {store.store_name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Membership <span className="text-red-500">*</span></label>
                    <div className="border rounded-xl p-3 space-y-2 max-h-40 overflow-y-auto">
                      <label className="flex items-center gap-2 text-sm font-medium">
                        <input type="checkbox" checked={isAllMemberships} onChange={toggleAllMemberships} />
                        Select all
                      </label>
                      {membershipList.map((m) => (
                        <label key={m.id} className="flex items-center gap-2 text-sm">
                          <input
                            type="checkbox"
                            checked={formData.memberships.includes(m.id)}
                            onChange={() => toggleMembership(m.id)}
                          />
                          {m.program_name}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Voucher Name <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <input
                        type="text"
                        name="voucher_name"
                        value={formData.voucher_name || ""}
                        onChange={handleChange}
                        placeholder="Voucher Name"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <Gift className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">No of voucher <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <input
                        type="text"
                        name="no_of_voucher"
                        value={formData.no_of_voucher || ""}
                        onChange={handleChange}
                        placeholder="No of voucher"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <Gift className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                  <div>
                    {/* <label className="block text-sm font-medium mb-1">Discount value </label> */}
                    {['1', '2'].map((type) => (
                      <label key={type} className="inline-flex items-center gap-2">
                        <input
                          type="radio"
                          name="discount_type"
                          value={type}
                          checked={formData.discount_type === type}
                          onChange={handleChange}
                        // className="accent-[#f4a406]"
                        />
                        <span className="text-sm font-medium">
                          {type === "2" ? "% Discount value" : "Fixed Discount value"}
                        </span>&nbsp;
                      </label>
                    ))}
                    <div className="relative">
                      <input
                        type="text"
                        name="discount_value"
                        value={formData.discount_value || ""}
                        onChange={handleChange}
                        placeholder="Dicsount value"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <Coins className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Voucher Price <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <input
                        type="number"
                        min="0"
                        name="voucher_price"
                        value={formData.voucher_price || ""}
                        onChange={handleChange}
                        placeholder="Voucher price"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <Coins className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Max Discount Value <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <input
                        type="number"
                        min="0"
                        name="max_discount_value"
                        value={formData.max_discount_value || ""}
                        onChange={handleChange}
                        disabled={formData.discount_type === '1'}
                        placeholder="Max discount value"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406] disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
                      />
                      <Coins className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                </div>


                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                  {/* <div>
                    <div className=" gap-6">
                      {['0', '1'].map((type) => (
                        <label key={type} className="inline-flex items-center gap-2">
                          <input
                            type="radio"
                            name="gtcoin_required"
                            value={type}
                            checked={formData.gtcoin_required === type}
                            onChange={handleChange}
                          // className="accent-[#f4a406]"
                          />
                          <span className="text-sm font-medium">
                            {type === "1" ? "Yes" : "No"}
                          </span>&nbsp;
                        </label>
                      ))}
                      <div>
                        <label className="block text-sm font-medium mb-1">GTcoin Required</label>
                        <div className="relative">
                          <input
                            type="number"
                            name="required_value"
                            value={formData.required_value || ""}
                            onChange={handleChange}
                            placeholder="Total value"
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          />
                          <Coins className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>

                    </div>
                  </div> */}
                   <div>
                    <label className="block text-sm font-medium mb-1">Min. Purchase Value <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <input
                        type="number"
                        name="min_purchase_value"
                        value={formData.min_purchase_value || ''}
                        onChange={handleChange}
                        placeholder="Minimum purchase value"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406] disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
                      />
                      <Coins className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>

                  {/* <div>
                    <label className="block text-sm font-medium mb-1">Redeem At</label>
                    <div className="relative">
                      <select name="redemption_type" value={formData.redemption_type || "3"} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      >
                        <option value="1">Online</option>
                        <option value="2">Offline</option>
                        <option value="3">Both (Online &amp; Offline)</option>
                      </select>
                      <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div> */}

                  <div>
                    <label className="block text-sm font-medium mb-1">Customer Share (%) <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        name="customer_share"
                        value={formData.customer_share ?? ""}
                        onChange={handleChange}
                        placeholder="Customer share %"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <Coins className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">Owner Share (%) <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        name="owner_share"
                        value={formData.owner_share ?? ""}
                        onChange={handleChange}
                        placeholder="Owner share %"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <Coins className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                  <p className={`text-xs md:col-span-2 ${shareTotal === 100 ? 'text-green-600' : 'text-red-500'}`}>
                    Total share: {shareTotal}% (must be exactly 100%)
                  </p>

                  <div>
                    <label className="block text-sm font-medium mb-1">Status</label>
                    <div className="relative">
                      <select name="is_active" value={formData.is_active || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      >
                        <option value="" disabled>Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                      <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">Valid From Date (optional)</label>
                    <div className="relative">
                      <DateInput
                        valueFormat="DD-MM-YYYY"
                        placeholder="Pick Valid From Date"
                        value={formData.valid_from}
                        onChange={(date) => {
                          handleChange(date, 'valid_from');
                          // reset toDate if it's before the new fromDate
                          if (formData.valid_to && date && formData.valid_to < date) {
                            handleChange(null, 'valid_to');//setToDate(null);
                          }
                        }}
                        leftSection={<CalendarDays size={18} className="text-gray-400" />}
                        className="w-full rounded-xl"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Valid To Date (optional)</label>
                    <div className="relative">
                      <DateInput
                        valueFormat="DD-MM-YYYY"
                        minDate={formData.valid_from || undefined}
                        placeholder="Pick Valid To Date"
                        value={formData.valid_to}
                        onChange={(date) => {
                          handleChange(date, 'valid_to');
                        }}
                        leftSection={<CalendarDays size={18} className="text-gray-400" />}
                        className="w-full rounded-xl"
                      />

                    </div>
                  </div>
                  {/* <div>
                    <label className="block text-sm font-medium mb-1">Voucher Image</label>
                    <div className="flex items-center gap-4">
                      <div className="relative flex-1">
                        <input
                          type="file"
                          ref={fileInputRef}
                          name="reward_logo"
                          accept="image/*"
                          onChange={handleChangeImg}
                          className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406] file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#f4a406] file:text-white hover:file:bg-yellow-600"
                        />
                        <Image className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">Preview Image</label>
                    <div className="flex items-center gap-4">
                      <div className="relative flex-1">
                        {formData.reward_logo && (
                          <div className="w-full border rounded-xl overflow-hidden">
                            <img
                              src={
                                typeof formData.reward_logo === 'string'
                                  ? `${formData.reward_logo}`
                                  : formData.reward_logo_preview
                              }
                              alt="Uploaded Preview"
                              className="w-full h-full object-cover"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div> */}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Terms & Condition <span className="text-red-500">*</span></label>
                    <div className="relative">
                      <textarea
                        type="text"
                        name="terms_condition"
                        value={formData.terms_condition || ""}
                        onChange={handleChange}
                        placeholder="terms_condition"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                </div>

              </div>
              </fieldset>
              {!isViewOnly && (
                  <div className="flex justify-end border-t px-6 py-4">
                      <button
                          disabled={loadingSave}
                          type="submit"
                          className="w-full bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors"
                      >
                          {loadingSave ? "Please wait..." : "Save"}
                      </button>
                  </div>
              )}
            </div>
          </form>
        </div>
      )}

      <div className="w-full  bg-white shadow-lg rounded-2xl p-6">

        <div className="grid grid-flow-col grid-rows-3 gap-4">
          <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Voucher</h2></div>
          <div className="row-start-1 row-end-4 text-right">
            <button type="button" onClick={handleOpen} className=" px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors">Add New</button>
          </div>
        </div>
        <div className="overflow-auto">

          <table className="w-full text-sm text-left">
            <thead className="text-gray-700 bg-gray-100">
              <tr>
                <th className="p-3">ID</th>
                <th className="p-3">Voucher Name</th>
                <th className="p-3">Store name</th>
                <th className="p-3">No of voucher</th>
                <th className="p-3">Membership</th>
                <th className="p-3">Dis. value</th>
                <th className="p-3">Voucher price</th>
                <th className="p-3">Max dis. value</th>
                {/* <th className="p-3">Redeem</th> */}
                {/* <th className="p-3">Cust / Owner %</th> */}
                <th className="p-3">Status</th>
                <th className="p-3">Created On</th>
                <th className="p-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {loading ? (
                <>
                  <tr>
                    <td className="p-3" colSpan={14}>
                      <ShimmerLoader />
                      <ShimmerLoader />
                      <ShimmerLoader />
                    </td>
                  </tr>
                </>
              ) : (
                <>
                  {voucher.length > 0 ? (
                    voucher.map((item, key) => (
                      <>
                        <tr key={item.id}>
                          <td className="p-3">{item.id}</td>
                          <td className="p-3">{item.voucher_name}</td>
                          <td className="p-3">{item.store_name}</td>
                          <td className="p-3">{item.no_of_voucher} </td>
                          <td className="p-3">{item.membership_names || '-'}</td>
                          <td className="p-3" nowrap="true">{item.discount_value}{item.discount_type === 2 ? ' %' : ' Fixed'}</td>
                          <td className="p-3">{item.voucher_price}</td>
                          <td className="p-3">{item.max_discount_value}</td>
                          {/* <td className="p-3">{redeemLabel[item.redemption_type] || '-'}</td> */}
                          {/* <td className="p-3" nowrap="true">{item.customer_share} / {item.owner_share}</td> */}
                          {/* <td className="p-3">{(item.is_active === 1) ? 'Active' : 'Inactive'}</td> */}
                          <td className="p-3">
                            {Number(item.approval_status) === 0 ? (
                              <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">Pending approval</span>
                            ) : Number(item.approval_status) === 2 ? (
                              <div>
                                <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">Rejected</span>
                                {item.reject_reason && (
                                  <div className="mt-1 text-xs text-red-600 max-w-[220px] whitespace-normal">Reason: {item.reject_reason}</div>
                                )}
                              </div>
                            ) : (
                              (item.is_active === 1) ? 'Active' : 'Inactive'
                            )}
                          </td>
                          <td className="p-3" nowrap="true">{item.createdDate} </td>
                          <td className="p-3 text-center space-x-2" nowrap="true">
                            {/* <button onClick={() => handleEdit(item)} className="text-[#f4a406] hover:underline inline-flex items-center gap-1">
                              <Edit size={16} />
                            </button> */}
                            <button
                                type="button"
                                onClick={() => handleEdit(item)}
                                title={
                                    item.used_status != null
                                        ? "View voucher (already bought)"
                                        : "Edit voucher"
                                }
                                className="inline-flex items-center gap-1 text-[#f4a406] hover:underline"
                            >
                                {item.used_status != null
                                    ? <Eye size={16} />
                                    : <Edit size={16} />}
                            </button>
                          </td>
                        </tr>
                      </>
                    ))
                  ) : (
                    <tr>
                      <td className="p-3" colSpan={14}>
                        No record found
                      </td>
                    </tr>
                  )}

                </>
              )}

            </tbody>
          </table>
          <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </div>
  );
}